import "@/components/Portal/components/PortalDeviceTiles/PortalDeviceTiles.scss";

import { FC } from "react";

import { PortalDeviceTiles } from "@/components/Portal/components/PortalDeviceTiles/PortalDeviceTiles";
import { portalRoutes } from "@/router/routes/portalRoutes";

import { MySubscriptionsLayout } from "./MySubscriptionsLayout";

/**
 * MySubscriptions component displays a list of SIM card tiles for the customer.
 * It provides features like filtering, infinite scrolling, and is specifically
 * designed to show only SIM cards without additional promotional or meta tiles.
 *
 * @returns {JSX.Element} The rendered MySubscriptions component.
 */
export const MySubscriptions: FC = () => (
  <MySubscriptionsLayout>
    <PortalDeviceTiles
      manageRoute={portalRoutes.manageDevice.base}
      showMetaTiles={false}
      showPromo={false}
      sortByDisplayPriority={true}
    />
  </MySubscriptionsLayout>
);
